/* eslint-disable */
import React, { useState, useEffect } from 'react';
import AdminLayout from './AdminLayout';
import { getInquiries, updateInquiry } from '../config/api';
import { X } from 'lucide-react';

export default function Inquiries() {
  const [inquiries,   setInquiries]   = useState([]);
  const [filter,      setFilter]      = useState('all');
  const [meta,        setMeta]        = useState({ total: 0, unread: 0 });
  const [expandedId,  setExpandedId]  = useState(null);
  const [mobileModalInquiry, setMobileModalInquiry] = useState(null);
  const [loading,     setLoading]     = useState(true);
  const [page,        setPage]        = useState(1);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const res = await getInquiries({ status: filter, page, per_page: 20 });
        setInquiries(Array.isArray(res.data?.data) ? res.data.data : []);
        setMeta(res.data?.meta || { total: 0, unread: 0 });
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    };
    load();
  }, [filter, page]);

  const markAsRead = async (id) => {
    await updateInquiry(id, { is_read: true });
    setInquiries(inquiries.map(inq => inq.id === id ? { ...inq, is_read: true } : inq));
    setMeta({ ...meta, unread: Math.max(0, meta.unread - 1) });
  };

  const markAsUnread = async (id) => {
    await updateInquiry(id, { is_read: false });
    setInquiries(inquiries.map(inq => inq.id === id ? { ...inq, is_read: false } : inq));
    setMeta({ ...meta, unread: meta.unread + 1 });
  };

  const handleExpand = async (inq) => {
    if (expandedId === inq.id) { setExpandedId(null); return; }
    setExpandedId(inq.id);
    if (!inq.is_read) {
      try {
        await markAsRead(inq.id);
        if (filter === 'unread') {
          setInquiries(prev => prev.filter(i => i.id !== inq.id));
          setExpandedId(null);
        }
      } catch (e) { console.error(e); }
    }
  };

  const handleMarkUnread = async (id) => {
    try {
      await markAsUnread(id);
      if (filter === 'read') {
        setInquiries(prev => prev.filter(i => i.id !== id));
      }
      setExpandedId(null);
    } catch (e) { console.error(e); }
  };

  const handleCardClick = async (inq) => {
    setMobileModalInquiry(inq);
    if (!inq.is_read) {
      try {
        await markAsRead(inq.id);
        setMobileModalInquiry(prev => prev ? { ...prev, is_read: true } : null);
        if (filter === 'unread') {
          setInquiries(prev => prev.filter(i => i.id !== inq.id));
        }
      } catch (e) { console.error(e); }
    }
  };

  const handleMarkUnreadMobile = async () => {
    if (!mobileModalInquiry) return;
    try {
      await markAsUnread(mobileModalInquiry.id);
      if (filter === 'read') {
        setInquiries(prev => prev.filter(i => i.id !== mobileModalInquiry.id));
      }
      setMobileModalInquiry(null);
    } catch (e) { console.error(e); }
  };

  useEffect(() => {
    if (!mobileModalInquiry) return;

    document.body.style.overflow = 'hidden';

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        setMobileModalInquiry(null);
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [mobileModalInquiry]);

  const tabStyle = (active) => ({
    padding: '8px 18px',
    fontSize: 12,
    fontFamily: 'var(--font-body)',
    background: 'none',
    border: 'none',
    borderBottom: active ? '2px solid var(--color-accent)' : '2px solid transparent',
    color: active ? 'var(--color-accent)' : 'var(--color-muted)',
    cursor: 'pointer',
    transition: 'all 0.15s',
  });

  return (
    <AdminLayout title="Inquiries">

      <div style={{ display: 'flex', gap: 16, marginBottom: 16, fontFamily: 'var(--font-body)', fontSize: 13 }}>
        <span style={{ color: 'var(--color-muted)' }}>Total: <strong style={{ color: 'var(--color-text)' }}>{meta.total}</strong></span>
        <span style={{ color: 'var(--color-muted)' }}>Unread: <strong style={{ color: 'var(--color-accent)' }}>{meta.unread}</strong></span>
      </div>

      <div style={{ display: 'flex', borderBottom: '1px solid var(--color-border)', marginBottom: 20 }}>
        {[['all', 'All'], ['unread', `Unread ${meta.unread}`], ['read', 'Read']].map(([val, label]) => (
          <button key={val} style={tabStyle(filter === val)} onClick={() => { setFilter(val); setPage(1); }}>
            {label}
          </button>
        ))}
      </div>

      {loading ? (
        <div style={{ padding: 40, textAlign: 'center', color: 'var(--color-muted)', fontFamily: 'var(--font-body)' }}>Loading...</div>
      ) : inquiries.length === 0 ? (
        <div style={{ padding: 40, textAlign: 'center', color: 'var(--color-muted)', fontFamily: 'var(--font-body)' }}>No inquiries found.</div>
      ) : (
        <>
        <table className="admin-table-desktop" style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, fontFamily: 'var(--font-body)' }}>
          <thead>
            <tr>
              {['', 'Name', 'Shoot Type', 'Date', 'Submitted', 'Action'].map(h => (
                <th key={h} style={{ textAlign: 'left', padding: '8px 12px', fontSize: 10, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--color-muted)', borderBottom: '1px solid var(--color-border)' }}>
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {inquiries.map(inq => (
              <React.Fragment key={inq.id}>
                <tr style={{ borderBottom: '1px solid var(--color-border)', background: expandedId === inq.id ? 'var(--color-surface-alt)' : 'transparent' }}>
                  <td style={{ padding: '12px' }}>
                    <div style={{ width: 8, height: 8, borderRadius: '50%', background: inq.is_read ? 'var(--color-border)' : 'var(--color-accent)' }} />
                  </td>
                  <td style={{ padding: '12px', fontWeight: inq.is_read ? 400 : 500, color: 'var(--color-text)' }}>
                    {inq.full_name}
                  </td>
                  <td style={{ padding: '12px' }}>
                    <span style={{ display: 'inline-block', padding: '2px 9px', borderRadius: 10, fontSize: 10, background: 'var(--color-surface-alt)', color: 'var(--color-muted)' }}>
                      {inq.shoot_type}
                    </span>
                  </td>
                  <td style={{ padding: '12px', color: 'var(--color-muted)', fontSize: 11 }}>
                    {new Date(inq.preferred_date).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}
                  </td>
                  <td style={{ padding: '12px', color: 'var(--color-muted)', fontSize: 11 }}>
                    {new Date(inq.submitted_at).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: '2-digit' })}
                  </td>
                  <td style={{ padding: '12px' }}>
                    <button
                      onClick={() => handleExpand(inq)}
                      style={{ padding: '4px 10px', border: '1px solid var(--color-border)', background: 'transparent', fontSize: 11, cursor: 'pointer', color: 'var(--color-text)', borderRadius: 4, fontFamily: 'var(--font-body)' }}
                    >
                      {expandedId === inq.id ? 'Close' : 'View'}
                    </button>
                  </td>
                </tr>

                {expandedId === inq.id && (
                  <tr>
                    <td colSpan={6} style={{ padding: 0, borderBottom: '1px solid var(--color-border)' }}>
                      <div style={{ background: 'var(--color-surface-alt)', padding: '20px 24px' }}>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
                          <div>
                            <span style={{ fontSize: 10, color: 'var(--color-muted)', letterSpacing: '0.1em', textTransform: 'uppercase', display: 'block', marginBottom: 3 }}>Name</span>
                            <span style={{ fontSize: 13, color: 'var(--color-text)' }}>{inq.full_name}</span>
                          </div>
                          <div>
                            <span style={{ fontSize: 10, color: 'var(--color-muted)', letterSpacing: '0.1em', textTransform: 'uppercase', display: 'block', marginBottom: 3 }}>Email</span>
                            <a href={`mailto:${inq.email}`} style={{ fontSize: 13, color: 'var(--color-accent)', textDecoration: 'none' }}>{inq.email}</a>
                          </div>
                          {inq.phone && (
                            <div>
                              <span style={{ fontSize: 10, color: 'var(--color-muted)', letterSpacing: '0.1em', textTransform: 'uppercase', display: 'block', marginBottom: 3 }}>Phone</span>
                              <span style={{ fontSize: 13, color: 'var(--color-text)' }}>{inq.phone}</span>
                            </div>
                          )}
                          <div>
                            <span style={{ fontSize: 10, color: 'var(--color-muted)', letterSpacing: '0.1em', textTransform: 'uppercase', display: 'block', marginBottom: 3 }}>Shoot Type</span>
                            <span style={{ fontSize: 13, color: 'var(--color-text)' }}>{inq.shoot_type}</span>
                          </div>
                          <div>
                            <span style={{ fontSize: 10, color: 'var(--color-muted)', letterSpacing: '0.1em', textTransform: 'uppercase', display: 'block', marginBottom: 3 }}>Preferred Date</span>
                            <span style={{ fontSize: 13, color: 'var(--color-text)' }}>
                              {new Date(inq.preferred_date).toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' })}
                            </span>
                          </div>
                          <div>
                            <span style={{ fontSize: 10, color: 'var(--color-muted)', letterSpacing: '0.1em', textTransform: 'uppercase', display: 'block', marginBottom: 3 }}>Submitted</span>
                            <span style={{ fontSize: 13, color: 'var(--color-text)' }}>
                              {new Date(inq.submitted_at).toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' })}
                            </span>
                          </div>
                        </div>

                        <div style={{ borderTop: '1px solid var(--color-border)', paddingTop: 14, marginBottom: 16 }}>
                          <span style={{ fontSize: 10, color: 'var(--color-muted)', letterSpacing: '0.1em', textTransform: 'uppercase', display: 'block', marginBottom: 6 }}>Message</span>
                          <p style={{ fontSize: 13, color: 'var(--color-text)', lineHeight: 1.7, fontFamily: 'var(--font-body)' }}>{inq.message}</p>
                        </div>

                        <div style={{ display: 'flex', gap: 10 }}>
                          <a
                            href={`https://mail.google.com/mail/?view=cm&to=${encodeURIComponent(inq.email)}&su=${encodeURIComponent(`Re: Your ${inq.shoot_type} Shoot Inquiry`)}&body=${encodeURIComponent(`Hi ${inq.full_name},\n\n`)}`}
                            target="_blank"
                            rel="noreferrer"
                            style={{ padding: '7px 14px', border: '1px solid var(--color-accent)', background: 'transparent', fontSize: 11, cursor: 'pointer', color: 'var(--color-accent)', borderRadius: 4, fontFamily: 'var(--font-body)', textDecoration: 'none', display: 'inline-flex', alignItems: 'center' }}
                          >
                            Reply via Email
                          </a>
                          <button
                            onClick={() => handleMarkUnread(inq.id)}
                            style={{ padding: '7px 14px', border: '1px solid var(--color-border)', background: 'transparent', fontSize: 11, cursor: 'pointer', color: 'var(--color-text)', borderRadius: 4, fontFamily: 'var(--font-body)' }}
                          >
                            Mark as Unread
                          </button>
                          <button
                            onClick={() => setExpandedId(null)}
                            style={{ padding: '7px 14px', border: '1px solid var(--color-border)', background: 'transparent', fontSize: 11, cursor: 'pointer', color: 'var(--color-text)', borderRadius: 4, fontFamily: 'var(--font-body)' }}
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>

      {/* Mobile Card Layout */}
      <div className="admin-cards-mobile">
        {inquiries.map(inq => (
          <div
            key={inq.id}
            className="inquiry-card"
            onClick={() => handleCardClick(inq)}
          >
            <div className="inquiry-card-header">
              <span className="inquiry-card-name">{inq.full_name}</span>
              {!inq.is_read && (
                <span style={{
                  display: 'inline-block',
                  background: '#FEF3C7',
                  color: '#92400E',
                  fontSize: 10,
                  padding: '2px 8px',
                  borderRadius: 10,
                  fontFamily: 'var(--font-body)',
                  fontWeight: 600
                }}>
                  UNREAD
                </span>
              )}
            </div>
            <div className="inquiry-card-meta">
              <span>{new Date(inq.submitted_at).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}</span>
              <span>•</span>
              <span style={{
                display: 'inline-block',
                padding: '2px 9px',
                borderRadius: 10,
                fontSize: 10,
                background: 'var(--color-surface-alt)',
                color: 'var(--color-muted)'
              }}>
                {inq.shoot_type}
              </span>
            </div>
          </div>
        ))}
      </div>

      {/* Full-Screen Mobile Modal */}
      {mobileModalInquiry && (
        <div className="inquiry-modal" onClick={() => setMobileModalInquiry(null)}>
          <div className="inquiry-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="inquiry-modal-header">
              <span className="inquiry-modal-title">{mobileModalInquiry.full_name}</span>
              <button
                className="inquiry-modal-close"
                onClick={() => setMobileModalInquiry(null)}
                aria-label="Close"
              >
                <X size={24} />
              </button>
            </div>

            <div className="inquiry-modal-body">
              <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 16, marginBottom: 16 }}>
                <div>
                  <span style={{ fontSize: 10, color: 'var(--color-muted)', letterSpacing: '0.1em', textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>Email</span>
                  <a href={`mailto:${mobileModalInquiry.email}`} style={{ fontSize: 13, color: 'var(--color-accent)', textDecoration: 'none', fontFamily: 'var(--font-body)' }}>
                    {mobileModalInquiry.email}
                  </a>
                </div>

                {mobileModalInquiry.phone && (
                  <div>
                    <span style={{ fontSize: 10, color: 'var(--color-muted)', letterSpacing: '0.1em', textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>Phone</span>
                    <span style={{ fontSize: 13, color: 'var(--color-text)', fontFamily: 'var(--font-body)' }}>{mobileModalInquiry.phone}</span>
                  </div>
                )}

                <div>
                  <span style={{ fontSize: 10, color: 'var(--color-muted)', letterSpacing: '0.1em', textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>Shoot Type</span>
                  <span style={{ fontSize: 13, color: 'var(--color-text)', fontFamily: 'var(--font-body)' }}>{mobileModalInquiry.shoot_type}</span>
                </div>

                <div>
                  <span style={{ fontSize: 10, color: 'var(--color-muted)', letterSpacing: '0.1em', textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>Preferred Date</span>
                  <span style={{ fontSize: 13, color: 'var(--color-text)', fontFamily: 'var(--font-body)' }}>
                    {new Date(mobileModalInquiry.preferred_date).toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' })}
                  </span>
                </div>

                <div>
                  <span style={{ fontSize: 10, color: 'var(--color-muted)', letterSpacing: '0.1em', textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>Submitted</span>
                  <span style={{ fontSize: 13, color: 'var(--color-text)', fontFamily: 'var(--font-body)' }}>
                    {new Date(mobileModalInquiry.submitted_at).toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' })}
                  </span>
                </div>
              </div>

              <div style={{ borderTop: '1px solid var(--color-border)', paddingTop: 16 }}>
                <span style={{ fontSize: 10, color: 'var(--color-muted)', letterSpacing: '0.1em', textTransform: 'uppercase', display: 'block', marginBottom: 8 }}>Message</span>
                <p style={{ fontSize: 13, color: 'var(--color-text)', lineHeight: 1.7, fontFamily: 'var(--font-body)' }}>
                  {mobileModalInquiry.message}
                </p>
              </div>
            </div>

            <div className="inquiry-modal-footer">
              <a
                href={`https://mail.google.com/mail/?view=cm&to=${encodeURIComponent(mobileModalInquiry.email)}&su=${encodeURIComponent(`Re: Your ${mobileModalInquiry.shoot_type} Shoot Inquiry`)}&body=${encodeURIComponent(`Hi ${mobileModalInquiry.full_name},\n\n`)}`}
                target="_blank"
                rel="noreferrer"
                style={{
                  padding: '12px 16px',
                  background: 'var(--color-accent)',
                  color: '#fff',
                  border: 'none',
                  fontSize: 11,
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                  cursor: 'pointer',
                  borderRadius: 4,
                  fontFamily: 'var(--font-body)',
                  textDecoration: 'none',
                  display: 'inline-block',
                  textAlign: 'center'
                }}
              >
                Reply via Email
              </a>
              {mobileModalInquiry.is_read && (
                <button
                  onClick={handleMarkUnreadMobile}
                  style={{
                    padding: '12px 16px',
                    border: '1px solid var(--color-border)',
                    background: 'transparent',
                    fontSize: 11,
                    letterSpacing: '0.08em',
                    textTransform: 'uppercase',
                    cursor: 'pointer',
                    color: 'var(--color-text)',
                    borderRadius: 4,
                    fontFamily: 'var(--font-body)'
                  }}
                >
                  Mark as Unread
                </button>
              )}
              <button
                onClick={() => setMobileModalInquiry(null)}
                style={{
                  padding: '12px 16px',
                  border: '1px solid var(--color-border)',
                  background: 'transparent',
                  fontSize: 11,
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                  cursor: 'pointer',
                  color: 'var(--color-text)',
                  borderRadius: 4,
                  fontFamily: 'var(--font-body)'
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
        </>
      )}

      {meta.pages > 1 && (
        <div style={{ display: 'flex', gap: 10, justifyContent: 'center', marginTop: 24, alignItems: 'center' }}>
          <button
            onClick={() => setPage(p => Math.max(1, p - 1))}
            disabled={page === 1}
            style={{ padding: '7px 16px', border: '1px solid var(--color-border)', background: 'transparent', fontSize: 12, cursor: page === 1 ? 'not-allowed' : 'pointer', color: 'var(--color-muted)', borderRadius: 4, fontFamily: 'var(--font-body)', opacity: page === 1 ? 0.5 : 1 }}
          >
            ← Prev
          </button>
          <span style={{ fontSize: 12, color: 'var(--color-muted)', fontFamily: 'var(--font-body)' }}>
            Page {page} of {meta.pages}
          </span>
          <button
            onClick={() => setPage(p => Math.min(meta.pages, p + 1))}
            disabled={page === meta.pages}
            style={{ padding: '7px 16px', border: '1px solid var(--color-border)', background: 'transparent', fontSize: 12, cursor: page === meta.pages ? 'not-allowed' : 'pointer', color: 'var(--color-muted)', borderRadius: 4, fontFamily: 'var(--font-body)', opacity: page === meta.pages ? 0.5 : 1 }}
          >
            Next →
          </button>
        </div>
      )}

    </AdminLayout>
  );
}